<template>
  <div
    class="dropdown"
    @blur="dropdownOpen = false"
  >
    <button
      class="selected body-3"
      @click="toggleDropdown()"
    >
      <slot name="icon" />
      <span>{{ itemSelected.label }}</span>
    </button>
    <ul
      class="options"
      :class="{ active: dropdownOpen }"
    >
      <li
        v-for="item in items"
        :key="item.code"
      >
        <button
          class="options__item body-3"
          @click="selectItem(item)"
        >
          {{ item.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import type { SelectItem } from '~/types/General/Elements/SelectItem'

  const props = defineProps({
    items: {
      type: Array<SelectItem>,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    }
  })

  const emit = defineEmits(['select'])

  const itemSelected = ref(props.selectedItem)

  const dropdownOpen = ref<boolean>(false)

  function toggleDropdown() {
    dropdownOpen.value = !dropdownOpen.value
  }

  function selectItem(item: Object) {
    dropdownOpen.value = false
    itemSelected.value = item

    emit('select', item)
  }

  // TODO: Click outside
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .dropdown {
    position: relative;

    .selected {
      color: $bt-blue;
      border: none;
      background-color: transparent;
      padding: rem(12);
      display: flex;
      gap: 8px;
      align-items: center;

      &:after {
        content: url('~/assets/icons/arrow-full.svg');
        position: relative;
        top: -2px;
      }
    }
  }

  .options {
    background-color: $white;
    border-radius: 4px;
    box-shadow: 0px 4px 4px rgba(106, 119, 142, 0.15);
    display: none;
    padding: rem(16);
    position: absolute;
    top: 36px;
    list-style: none;

    &.active {
      display: block;
      z-index: 10;
    }

    &__item {
      color: $bt-blue;
      line-height: rem(24);
      margin-bottom: rem(8);
      white-space: nowrap;
      border: none;
      background-color: transparent;
      width: 100%;
      text-align: left;
    }
  }
</style>
